export default function initShowMore() {
  const elements = document.querySelectorAll('.js-show-more');

  if (elements.length == 0) return;

  elements.forEach(element => {
    const button = element.querySelector('.js-show-more-btn');

    if (!button) return;

    button.addEventListener('click', (e) => {
      e.preventDefault();
      element.classList.add('is-active');
    })
  })
}